

import React from "react";

const CGTLogo = ({logo}) => {
  return <div className="cgtIcon">
    <img src={logo} alt="CGT_warning"/>
  </div>;
};

export default CGTLogo;
